// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Data_Id$Coronate from "./Data_Id.bs.js";

function toString(data) {
  switch (data) {
    case /* Person */0 :
        return "person";
    case /* Dummy */1 :
        return "dummy";
    case /* Missing */2 :
        return "missing";
    
  }
}

function fromString(str) {
  switch (str) {
    case "dummy" :
        return /* Dummy */1;
    case "missing" :
        return /* Missing */2;
    case "person" :
        return /* Person */0;
    default:
      return /* Person */0;
  }
}

var encode = toString;

function decode(data) {
  return fromString(Belt_Option.getExn(Js_json.decodeString(data)));
}

var Type = {
  toString: toString,
  fromString: fromString,
  encode: encode,
  decode: decode
};

function fullName(t) {
  return t.firstName + " " + t.lastName;
}

function decode$1(json) {
  var d = Js_json.decodeObject(json);
  var data = Belt_Option.getExn(Belt_Option.flatMap(d, (function (d) {
              return Js_dict.get(d, "type_");
            })));
  return {
          firstName: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "firstName");
                        })), Js_json.decodeString)),
          id: Data_Id$Coronate.decode(Belt_Option.getExn(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "id");
                        })))),
          lastName: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "lastName");
                        })), Js_json.decodeString)),
          matchCount: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "matchCount");
                        })), Js_json.decodeNumber)) | 0,
          rating: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "rating");
                        })), Js_json.decodeNumber)) | 0,
          type_: fromString(Belt_Option.getExn(Js_json.decodeString(data)))
        };
}

function encode$1(data) {
  return Js_dict.fromArray([
              [
                "firstName",
                data.firstName
              ],
              [
                "id",
                Data_Id$Coronate.encode(data.id)
              ],
              [
                "lastName",
                data.lastName
              ],
              [
                "matchCount",
                data.matchCount
              ],
              [
                "rating",
                data.rating
              ],
              [
                "type_",
                toString(data.type_)
              ]
            ]);
}

var dummy = {
  firstName: "[Bye]",
  id: Data_Id$Coronate.dummy,
  lastName: "",
  matchCount: 0,
  rating: 0,
  type_: /* Dummy */1
};

function makeMissing(id) {
  return {
          firstName: "Anonymous",
          id: id,
          lastName: "Player",
          matchCount: 0,
          rating: 0,
          type_: /* Missing */2
        };
}

function getMaybe(playerMap, id) {
  if (Data_Id$Coronate.isDummy(id)) {
    return dummy;
  } else {
    return Belt_Map.getWithDefault(playerMap, id, makeMissing(id));
  }
}

export {
  Type ,
  fullName ,
  encode$1 as encode,
  decode$1 as decode,
  dummy ,
  getMaybe ,
  
}
/* Data_Id-Coronate Not a pure module */
